import { MapPin, TrendingUp, ArrowUpRight } from "lucide-react";
import { cn } from "@/lib/utils";
import { useNavigate } from "react-router-dom";

interface LaneSummaryCardProps {
  origin: string;
  destination: string;
  avgRpm: number;
  rpmChange: number;
  postedLoads: number;
  equipment?: string;
}

export function LaneSummaryCard({ origin, destination, avgRpm, rpmChange, postedLoads, equipment }: LaneSummaryCardProps) {
  const positive = rpmChange >= 0;
  const navigate = useNavigate();

  const buildUrl = () => {
    const params = new URLSearchParams();
    params.set('origin', origin);
    params.set('destination', destination);
    params.set('source', 'lane-summary');
    if (equipment) params.set('equipment', equipment);
    return `/search?${params.toString()}`;
  };

  return (
    <div className="rounded-lg border bg-card p-3 xl:p-3.5 space-y-3">
      <div className="flex items-center gap-1.5">
        <MapPin className="h-3.5 w-3.5 text-accent" />
        <span className="text-[12px] xl:text-[13px] font-bold text-foreground">{origin} – {destination}</span>
      </div>
      <div>
        <p className="text-[11px] text-muted-foreground">Avg. ${avgRpm.toFixed(3)} RPM</p>
        <div className="flex items-center gap-1.5 mt-1">
          <span className="h-2.5 w-2.5 rounded-full bg-warning inline-block flex-shrink-0" />
          <span className={cn("text-[11px] font-semibold flex items-center gap-0.5", positive ? "text-success" : "text-danger")}>
            {positive ? "+" : ""}{rpmChange}%
          </span>
          <span className="text-[11px] text-muted-foreground">{positive ? "increase" : "decrease"} today</span>
        </div>
        <p className="text-[11px] text-muted-foreground mt-1">{postedLoads.toLocaleString()} posted loads last 7 days</p>
      </div>
      <button
        onClick={() => navigate(buildUrl())}
        className="w-full flex items-center justify-between rounded-md border border-border bg-muted/30 px-3 py-1.5 text-[11px] font-medium text-foreground hover:bg-muted transition-colors"
      >
        <div className="flex items-center gap-1.5">
          <TrendingUp className="h-3 w-3 text-success" />
          <span>Suggested profitable lanes</span>
        </div>
        <ArrowUpRight className="h-3 w-3 text-muted-foreground" />
      </button>
    </div>
  );
}
